import Navbar from '../components/Navbar';
import About from '../components/About';
import Footer from '../components/Footer';

export default function AboutPage() {
  return (
    <div className="font-poppins">
      <Navbar />
      <About />
      <Footer />
    </div>
  );
}
